import { useTheme } from "@/contexts/ThemeContext";
import SuggestionIcon from "./SuggestionIcon";
import { ACCENT, ACCENT_LIGHT, CHIP_ICON } from "../homeTokens";

/**
 * The shortcut row under the ask box.
 *
 * Suggestions are passed in rather than hardcoded so they can follow what is
 * actually happening in the account — a channel that just failed to send gets
 * a shortcut about that error instead of a generic list. The fallback set is
 * only used when nothing specific is known.
 */
export default function LucasSuggestions({ suggestions = [], onPick }) {
  const { resolved } = useTheme();
  const accents = resolved === "light" ? ACCENT_LIGHT : ACCENT;

  if (!suggestions.length) return null;

  return (
    <div className="mt-4 flex flex-wrap justify-center gap-2">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.text}
          type="button"
          onClick={() => onPick(suggestion.text)}
          className={CHIP_ICON}
        >
          <SuggestionIcon icon={suggestion.icon} color={accents[suggestion.tone]} />
          {suggestion.text}
        </button>
      ))}
    </div>
  );
}
